/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Onboarding/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ApptTypes from './ApptTypes/index'
import CsvNoteTemplates from './CsvNoteTemplates/index'
import CsvProcedures from './CsvProcedures/index'
import CsvTxCardFields from './CsvTxCardFields/index'
import DiscountChargesCorrections from './DiscountChargesCorrections/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Inputs from './Inputs/index'
import NotificationTemplates from './NotificationTemplates/index'
import React from 'react'
import TxCardFields from './TxCardFields/index'
import TxStatuses from './TxStatuses/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Onboarding({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let constantData = 'Onboarding setup for:'
let globalCurrentLocationParentCompanyNameValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.parent_company.name',
})
let aggregateData = fromAggregate.join(constantData, globalCurrentLocationParentCompanyNameValueData)
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="Onboarding.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-2nuxz4': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-2-2nuxz4': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-3-2nuxz4': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pb-4-2nuxz4': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h1"
 data="'Onboarding setup for:'"
 data="global.current_location.parent_company.name"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
 marginBottom={dtSpaceL}
/>
<TxCardFields
  viewPath={`${viewPath}/TxCardFields`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceL}
 marginBottom={dtSpaceL}
/>
<TxStatuses
  viewPath={`${viewPath}/TxStatuses`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceL}
 marginBottom={dtSpaceL}
/>
<DiscountChargesCorrections
  viewPath={`${viewPath}/DiscountChargesCorrections`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceL}
 marginBottom={dtSpaceL}
/>
<ApptTypes
  viewPath={`${viewPath}/ApptTypes`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceL}
 marginBottom={dtSpaceL}
/>
<CsvTxCardFields
  viewPath={`${viewPath}/CsvTxCardFields`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceL}
 marginBottom={dtSpaceL}
/>
<CsvProcedures
  viewPath={`${viewPath}/CsvProcedures`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceL}
 marginBottom={dtSpaceL}
/>
<CsvNoteTemplates
  viewPath={`${viewPath}/CsvNoteTemplates`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceL}
 marginBottom={dtSpaceL}
/>
<NotificationTemplates
  viewPath={`${viewPath}/NotificationTemplates`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceL}
 marginBottom={dtSpaceL}
/>
<Inputs
  viewPath={`${viewPath}/Inputs`}
/>
</div>
{children}
</React.Fragment>)
}